<script>
  const icon_chat = "/assets_default/images/business/guide/icon_chat.svg"
  const icon_help = "/assets_default/images/business/guide/icon_help.svg"

  const list = [
    {
      icon: icon_help,
      title: "お困りのお客さま",
      text: "さまざまなよくある質問や<br class=\"show:sp\">お問合わせにお答えできる<br>サポートページをご用意しております。",
      link: {
        url: "https://cs-faq.minna-no-ginko.com/category/show/82",
        text: "よくある質問はこちら"
      }
    },
    {
      icon: icon_chat,
      title: "お問合わせ",
      text: "Mail : <a href=\"mailto:business_account-support@cs.minna-no-ginko.com\" class=\"owd-textlink mail-link\">business_account-support@cs.minna-no-ginko.com</a><br>営業時間：9時-17時　※年末年始除く",
      link: {
        url: "https://faq.minna-no-ginko.com/s/biz-contact-support",
        text: "お問合わせはこちら"
      }
    }
  ]
</script>

<div class="more-section owd-biz-section:max:1200">
  {#each list as item}
  <div class="more-item">
    <div class="icon">
      <img src={item.icon} alt="イメージアイコン">
    </div>
    <p class="owd-heading:02 align:center more-section-title">{item.title}</p>
    <p class="owd-text:01 align:center spacing:bottom:40 more-section-text">{@html item.text}</p>
    <a href={item.link.url} target="_blank" class="owd-button owd-button:large owd-button:secondary:white">{item.link.text}</a>
  </div>
  {/each}
</div>

<style lang="scss">
.more{
  &-section{
    padding: 80px 0;
    display: grid;
    gap: 32px;
    grid-template-columns: repeat(2,1fr);
    &-title{
      margin-bottom: 24px;
    }
  }
  &-item{
    background-color: var(--primary-white);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 48px;
    .icon{
      background-color: var(--accent);
      aspect-ratio: 1;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 56px;
      margin-bottom: 16px;
      img{
        width: 24px;
      }
    }
  }
  @include g.mobile () {
  &-section{
    padding: 48px 0;
    gap: 16px;
    grid-template-columns: 1fr;
    &-title{
      margin-bottom: 16px;
      @include g.owd-typography($fz: 'heading-3', $line-height-px: 32, $letter-spacing-tracking: 25, $font-weight: 600);
    }
    &-text{
      @include g.owd-typography($fz: 'text-2', $line-height-px: 24, $letter-spacing-tracking: 50, $font-weight: var(--base-normal-weight));
      .mail-link{
        //要確認
        font-size: 12px;
        @include g.owd-typography($fz: 'caption', $line-height-px: 20, $letter-spacing-tracking: 50, $font-weight: var(--base-normal-weight));
      }
    }
  }
  &-item{
    padding: 32px 24px;
    .icon{
      margin-bottom: 24px;
    }
  }
  }
}
</style>
